import MediumArticles from '../components/shared/MediumArticles';
import ExploreMore from '../components/books/ExploreMore';
import Technologies  from '../components/shared/Technologies';
import BeforeFooter from '../components/layout/BeforeFooter';
import Hero from '../components/shared/Hero';
function Home() {
  return (
    <div>
      <Hero />
      <Technologies />
      <MediumArticles />
      <ExploreMore />
      <BeforeFooter />
     
    </div>
  );
}

export default Home;